<template>
  <div v-if="loading" class="text-center mt-5">
    <img src="https://cdn.gavleenergi.se/img/spinner.svg" width="100" />
  </div>
  <div v-if="!loading" class="row gx-lg-5">
    <div class="col-12 col-lg-7">
      <!--PAGES-->
      <template v-if="pages.length > 0">
        <h4>Sidor</h4>
        <div class="row border-top py-3 gx-0" v-for="item in pages.slice(0, 5)" :key="item.id">
          <div class="col-auto">
            <!--<i class="far fa-fw fa-info-circle fs-5" aria-hidden="true"></i>-->
            <i
              v-if="item.link.indexOf('/foretag/') != -1"
              title="För företag och Bostadsrättsföreningar"
              class="fa-fw far fa-briefcase me-3"
              aria-hidden="true"></i>
            <i v-else title="För privatpersoner" class="fa-fw far fa-user me-3" aria-hidden="true"></i>
          </div>
          <div class="col">
            <strong class="">
              <a :href="item.link" v-html="item.title.rendered"></a>
              <span v-if="item.link.indexOf('/foretag/') != -1" class="badge border px-1 rounded ms-2 text-muted">Företag</span></strong
            ><br />
            <div v-html="item.acf.ingress"></div>
          </div>
        </div>
      </template>

      <template v-if="projekt.length > 0">
        <h4 class="mt-5">Projekt</h4>
        <div class="row border-top py-3 gx-0" v-for="item in projekt.slice(0, 5)" :key="item.id">
          <div class="col-auto">
            <i title="projekt" class="fa-fw far fa-digging me-3" aria-hidden="true"></i>
          </div>
          <div class="col">
            <strong class="">
              <a :href="item.link" v-html="item.title.rendered"></a>
              </strong
            ><br />
            <div v-html="item.acf.ingress"></div>
          </div>
        </div>
      </template>

      <template v-if="posts.length > 0">
        <h4 class="mt-5">Nyheter</h4>
        <div class="row border-top py-3 gx-0" v-for="item in posts.slice(0, 7)" :key="item.id">
          <div class="col-auto">
            <i class="far fa-fw fa-comment-alt-lines me-3" aria-hidden="true"></i>
          </div>
          <div class="col">
            <div v-html="item.date.slice(0, 10)"></div>
            <strong class=""><a :href="item.link" v-html="item.title.rendered"></a></strong><br />
            <div v-html="item.acf.ingress"></div>
          </div>
        </div>
      </template>

      <template v-if="site != 'glimten' && docs.length > 0">
        <h4 class="mt-5">Dokument</h4>
        <div class="row border-top py-3 gx-0" v-for="item in docs.slice(0, 7)" :key="item.id">
          <div class="col-auto">
            <i class="text far fa-fw fa-file-alt me-3" aria-hidden="true"></i>
          </div>
          <div class="col">
            <strong class=""><a :href="item.link" v-html="item.title.rendered"></a></strong>
          </div>
        </div>
      </template>
    </div>
    <!--FAQ-->
    <div v-if="faq.length > 0" class="col-12 col-lg-5">
      <div class="p-lg-5 p-2 bg-light" id="searchFaq">
        <h4>Vanliga frågor</h4>
        <div v-for="item in faq.slice(0, 10)" :key="item.id" class="accordion accordion-flush">
          <div class="accordion-item">
            <div class="accordion-header" id="flush-headingOne">
              <button
                class="accordion-button collapsed px-1"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#flush' + item.id"
                aria-expanded="false"
                :aria-controls="'flush' + item.id"
                v-html="item.title.rendered"></button>
            </div>
            <div :id="'flush' + item.id" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#searchFaq">
              <div class="acccordion-body">
                <div v-html="item.content.rendered"></div>
                <a v-if="item.acf.call_to_action" :href="item.acf.call_to_action_link" class="btn btn-primary" v-html="item.acf.call_to_action"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["query", "siteurl"],
  data() {
    let searchQuery = this.query;

    return {
      faq: [],
      pages: [],
      posts: [],
      docs: [],
      projekt: [],
      searchQuery,
      loading: true,
      site: "gn",
    };
  },

  methods: {
    async fetchAll() {
      if (this.siteurl.indexOf("bionar") !== -1) {
        (this.site = "bionar"), console.log(this.siteurl.indexOf("bionar"));
      } else if (this.siteurl.indexOf("gavlenet") !== -1) {
        this.site = "gn";
      } else if (this.siteurl.indexOf("glimten") !== -1) {
        this.site = "glimten";
      } else if (this.siteurl.indexOf("gavleenergi") !== -1) {
        (this.site = "geab"), console.log(this.siteurl.indexOf("geab"));
      }
      let urls = [];
      urls[0] = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/?site=" + this.site + "&type=search&search=" + this.searchQuery;
      urls[1] =
        this.siteurl +
        "/wp-json/wp/v2/pages?per_page=100&search=" +
        this.searchQuery +
        "&_fields=title,id,acf.searchable,link,acf.ingress,acf.searchable";
      urls[2] =
        this.siteurl + "/wp-json/wp/v2/posts?per_page=100&search=" + this.searchQuery + "&_fields=title,id,acf.searchable,link,acf.ingress,date";
      if (this.site != "glimten")
        urls[3] = this.siteurl + "/wp-json/wp/v2/dokument?per_page=100&search=" + this.searchQuery + "&_fields=title,id,acf.searchable,link";
        if (this.site == "gn" || this.site == "geab")
        urls[4] = this.siteurl + "/wp-json/wp/v2/projekt?per_page=100&search=" + this.searchQuery + "&_fields=title,id,acf.searchable,link";

      await Promise.all(urls.map((url) => fetch(url).then((res) => res.json()))).then((json) => {
        console.log(json);

        this.faq = this.sortItems(json[0]);
        this.pages = this.sortItems(json[1]);
        this.posts = this.sortItems(json[2].sort(this.compareDatesDesc), "posts");
        if (this.site != "glimten") {
          this.docs = this.sortItems(json[3]);
        }
        if (this.site == "gn" || this.site == "geab" ) {
          this.projekt = this.sortItems(json[4]);
        }


        //this.faq = json[0];
        //this.pages = json[1];
        //this.posts = json[2]
        //this.docs = json[3];

        this.loading = false;
      });
    },
    compareDatesAsc(a, b) {
      console.log(a.date);
      return a.date - b.date;
    },

    compareDatesDesc(a, b) {
      return b.date - a.date;
    },
    sortItems(arr) {
      arr = arr.filter((row) => {
        return row.acf.searchable !== false;
      });

      arr.sort((a, b) => new Date(b.date) - new Date(a.date));

      arr.sort((a, b) => {
        const aTitle = a.title.rendered.toLowerCase();
        const bTitle = b.title.rendered.toLowerCase();
        const searchQuery = this.searchQuery.toLowerCase();

        const aContainsSearch = aTitle.includes(searchQuery);
        const bContainsSearch = bTitle.includes(searchQuery);
        const aEqualsSearch = aTitle === searchQuery;
        const bEqualsSearch = bTitle === searchQuery;

        if (aContainsSearch && !bContainsSearch) {
          return -1;
        } else if (!aContainsSearch && bContainsSearch) {
          return 1;
        }

        if (aEqualsSearch && !bEqualsSearch) {
          return -1;
        } else if (!aEqualsSearch && bEqualsSearch) {
          return 1;
        }

        return 0;
      });

      return arr;
    },
  },

  mounted() {
    this.fetchAll();
  },
};
</script>
